import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom'; // Link इम्पोर्ट करें
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import SkillDevelopmentImage from '../images/SkillDevelopment.jpg';
import EducateaChildImage from '../images/EducateaChild.jpg';
import HealthcareAccess from '../images/HealthcareAccess.jpg';
import WomenEmpowerment from '../images/WomenEmpowerment.jpg';
import EnvironmentalProtection from '../images/EnvironmentalProtection.jpg';

const SupportCauseSection: React.FC = () => {
  const causes = [
    {
      title: 'Educate a Child',
      desc: 'Support free education for underprivileged children across India and help shape brighter futures.',
      image: EducateaChildImage,
    },
    {
      title: 'Skill Development',
      desc: 'Providing vocational training to equip youth with employable skills and empower their future.',
      image: SkillDevelopmentImage,
    },
    {
      title: 'Healthcare Access',
      desc: 'Bringing healthcare services to remote and at-need communities, ensuring access to essential care.',
      image: HealthcareAccess,
    },
    {
      title: 'Women Empowerment',
      desc: 'Empowering women to achieve independence through education and skill development.',
      image: WomenEmpowerment,
    },
    {
      title: 'Environmental Protection',
      desc: 'Support initiatives that drive sustainability and champion eco-friendly practices for a greener future.',
      image: EnvironmentalProtection,
    },
  ];

  // स्लाइडर सेटिंग्स
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="support-cause-section py-5">
      <Container>
      <h2 className="text-center mb-5 support-cause-title">Be the Change You Wish to See</h2>
        <Slider {...settings}>
          {causes.map((cause, index) => (
            <div key={index} className="support-cause-slide">
              <div className="support-cause-card">
                <img
                  src={cause.image}
                  alt={cause.title}
                  className="support-cause-image"
                />
                <div className="support-cause-content">
                  <h4 className="support-cause-heading">{cause.title}</h4>
                  <p className="support-cause-desc">{cause.desc}</p>
                  <Link to="/donate/">
                              <Button variant="danger" className="  me-2">
                                Donate Now
                              </Button>
                            </Link>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </Container>
    </section>
  );
};

export default SupportCauseSection;
